var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    {
      staticClass: "input input--checkbox-group",
      class: _vm.inputClass,
      attrs: { group: _vm.group }
    },
    [
      _vm.label ? _c("legend", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
      _vm._l(_vm.options, function(option) {
        return _c("label", [
          _vm._v(_vm._s(option.label)),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selected,
                expression: "selected"
              }
            ],
            attrs: {
              id: option.value,
              type: "checkbox",
              disabled: option.disabled,
              name: _vm.group
            },
            domProps: {
              value: option.value,
              checked: Array.isArray(_vm.selected)
                ? _vm._i(_vm.selected, option.value) > -1
                : _vm.selected
            },
            on: {
              change: [
                function($event) {
                  var $$a = _vm.selected,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = option.value,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.selected = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.selected = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.selected = $$c
                  }
                },
                function($event) {
                  $event.preventDefault()
                  return _vm.onChange($event)
                }
              ]
            }
          }),
          _c(
            "span",
            { staticClass: "checkbox-toggle" },
            [
              _c("icon", {
                staticClass: "checkbox-checkmark",
                attrs: { name: "checkmark_small", size: "10px" }
              })
            ],
            1
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }